module.exports = __webpack_public_path__ + "media/newstyle/images/icon-book-white-230f3c9e10154dfd504ec13a00744098.svg";